import { useState, useEffect } from "react";
import { fetchProducts } from "@/lib/api";
import ProductCard from "@/components/ProductCard";
import { Search as SearchIcon } from "lucide-react";

export default function Search() {
  const [query, setQuery] = useState("");
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    fetchProducts()
      .then(setProducts)
      .catch(() => setProducts([]))
      .finally(() => setLoading(false));
  }, []);

  const results = products.filter((p) => {
    if (!query) return false;
    const q = query.toLowerCase();
    return (
      (p.name && p.name.toLowerCase().includes(q)) ||
      (p.description && p.description.toLowerCase().includes(q)) ||
      (p.category_id && p.category_id.toLowerCase().includes(q))
    );
  });

  return (
    <div data-testid="search-page" className="min-h-screen">
      <section className="border-b-[3px] border-black bg-[var(--candy-blue)] candy-dots">
        <div className="max-w-4xl mx-auto px-5 md:px-8 py-12 md:py-20 text-center">
          <h1 className="font-display font-black uppercase text-5xl md:text-7xl tracking-tight mb-8 text-white" style={{ textShadow: "4px 4px 0 #000" }}>Find Your Fit</h1>
          
          <div className="relative max-w-2xl mx-auto">
            <input
              type="text"
              placeholder="Search for shirts, shoes, accessories..."
              value={query}
              onChange={(e) => setQuery(e.target.value)}
              className="w-full text-lg md:text-xl font-bold rounded-full nb-border py-4 pl-14 pr-6 focus:outline-none focus:ring-4 focus:ring-black"
              autoFocus
            />
            <SearchIcon className="absolute left-5 top-1/2 -translate-y-1/2 text-black/50" size={24} strokeWidth={3} />
          </div>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-5 md:px-8 py-12">
        {!query ? (
          <div className="text-center text-black/50 py-20">
            <SearchIcon size={48} className="mx-auto mb-4 opacity-30" strokeWidth={2} />
            <p className="text-xl font-bold">Type something above to start searching.</p>
          </div>
        ) : loading ? (
          <div className="text-center font-display font-black text-2xl py-20">Loading...</div>
        ) : results.length > 0 ? (
          <>
            <div className="mb-8 font-bold uppercase tracking-wide text-black/70">
              Found {results.length} result{results.length !== 1 && "s"} for "{query}"
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6 md:gap-8">
              {results.map((p, i) => (
                <ProductCard key={p.id} product={p} index={i} />
              ))}
            </div>
          </>
        ) : (
          <div className="text-center text-black/50 py-20">
            <p className="text-xl font-bold">No products found matching "{query}".</p>
            <p className="mt-2">Try checking for typos or using different keywords.</p>
          </div>
        )}
      </section>
    </div>
  );
}
